export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 58 958 444">
    <path d="M431.6 301.8H21.3C9.6 301.8 0 311.4 0 323.1v157.3c0 11.7 9.6 21.3 21.3 21.3h409.3c11.7 0 21.3-9.6 21.3-21.3V323.1c1-11.7-8.6-21.3-20.3-21.3m-159.4-43.6h409.3c11.7 0 21.3-9.6 21.3-21.3V79.6c0-11.7-9.6-21.3-21.3-21.3H272.2c-11.7 0-21.3 9.6-21.3 21.3v157.3c0 11.7 9.6 21.3 21.3 21.3m665.5 43.6H527.3c-11.7 0-21.3 9.6-21.3 21.3v157.3c0 11.7 9.6 21.3 21.3 21.3h409.3c11.7 0 21.3-9.6 21.3-21.3V323.1c1-11.7-8.5-21.3-20.2-21.3" />
  </svg>
);
